import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Button, Checkbox, Icon, Input, Select } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  updateAssignSiteData,
  checkAll,
  updateIsPageAccessible,
} from '../state/actions';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { TrackedCheckbox } from 'Components';
import { FieldEnum } from 'Common/FieldEnum';
import { groupNameOptions, subGroupNameOptions } from 'Common/Constants';

const isAllowed = 1;
class AssignSiteGridContainer extends Component {
  state = {
    filtered: [],
    expanded: [],
  };
  filterFunctionName = null;
  filterSubMenuGroup = null;

  onFilteredChange = filtered => this.setState({ filtered: filtered });

  render() {
    const { assignSiteData, isReadOnly } = this.props;

    return (
      <div className="assign-user-to-site">
        <Button
          className={'clear-filters-button'}
          content="Clear Filters"
          onClick={() => this.setState({ filtered: [], expanded: [] })}
        />
        <ReactTable
          loading={this.props.loading}
          defaultPageSize={15}
          showPageSizeOptions={false}
          minRows={15}
          expanded={this.state.expanded}
          data={assignSiteData}
          resizable={false}
          className="-striped -highlight" //modalGrid prevents padding at bottom
          defaultFilterMethod={caseInsensitiveFilter}
          onFilteredChange={this.onFilteredChange}
          filtered={this.state.filtered}
          onExpandedChange={(newExpanded, index, event) => {
            this.setState({ expanded: newExpanded });
          }}
          sortable={false}
          columns={[
            {
              expander: true,
              Header: '',
              width: 40,
              Expander: ({
                isExpanded,
                original: { AccessibleFunctions = [] },
              }) => {
                let props = {};

                if (isExpanded) {
                  props = { rotated: 'clockwise' };
                }

                return (
                  !!AccessibleFunctions.length && (
                    <Icon name="caret right" {...props} />
                  )
                );
              },
            },
            {
              Header: 'Id',
              accessor: 'Id',
              filterable: true,
            },
            {
              Header: 'Description',
              accessor: 'Description',
              filterable: true,
            },
            {
              Header: 'Site Group',
              accessor: 'SiteGroup',
              filterable: true,
            },
            {
              Header: currentRows => {
                return (
                  <span>
                    <Checkbox
                      checked={this.props.checkAllChecked === isAllowed}
                      onClick={(e, data) => {
                        this.props.checkAll(
                          data.checked ? 1 : 0,
                          currentRows.data
                        );
                      }}
                      disabled={
                        isReadOnly ||
                        !(assignSiteData && assignSiteData.length > 0)
                      }
                    />
                  </span>
                );
              },

              accessor: 'Allowed',
              maxWidth: 120,
              Cell: ({ original }) => {
                const initialValue = _.find(this.props.initialData, {
                  Id: original.Id,
                }).Allowed;
                return (
                  <div style={{ textAlign: 'center' }}>
                    <TrackedCheckbox
                      initialValue={initialValue === isAllowed}
                      checked={original.Allowed === isAllowed}
                      disabled={isReadOnly}
                      onChange={() => this.props.updateAssignSiteData(original)}
                    />
                  </div>
                );
              },
            },
          ]}
          SubComponent={({
            original: { AccessibleFunctions, Id, Allowed },
          }) => {

            if (!!AccessibleFunctions.length) {
              const initialAccessibleFunctions = _.find(
                this.props.initialData,
                {
                  Id: Id,
                }
              ).AccessibleFunctions;
              return (
                <ReactTable
                  filterable
                  defaultPageSize={AccessibleFunctions.length}
                  showPageSizeOptions={false}
                  defaultFilterMethod={(filter, row) =>
                    String(row[filter.AccessInfoId]) === filter.value
                  }
                  className="-striped -highlight modalGrid no-hover nested--react-table"
                  data={AccessibleFunctions}
                  resizable={false}
                  sortable={false}
                  showPagination={false}
                  columns={[
                    {
                      Header: 'Read Only Menu Access',
                      columns: [
                        {
                          Header: 'Group Name',
                          accessor: 'GroupName',
                          id: 'groupName',
                          filterMethod: (filter, rows) => {
                            if (filter.value === 0) return rows;
                            return caseInsensitiveFilter(filter, rows);
                          },
                          Filter: ({ filter, onChange }) => {
                            return (
                              <Select
                                onChange={(event, data) => {
                                  event.preventDefault();
                                  onChange(data.value);
                                  this.filterFunctionName = data.value;
                                }}
                                fluid
                                placeholder="Filter by GroupName"
                                options={groupNameOptions}
                              />
                            );
                          },
                        },
                        /**
                         * SubGroup Name Column
                         */
                        {
                          Header: 'SubGroup Name',
                          accessor: 'SubGroupName',
                          id: 'subGroupName',
                          filterMethod: (filter, rows) => {
                            if (filter.value === 0) return rows;
                            return caseInsensitiveFilter(filter, rows);
                          },
                          Filter: ({ filter, onChange }) => {
                            return (
                              <Select
                                onChange={(event, data) => {
                                  onChange(data.value);
                                  this.filterSubMenuGroup = data.value;
                                }}
                                fluid
                                placeholder="Filter by SubmenuGroup"
                                options={subGroupNameOptions}
                              />
                            );
                          },
                        },
                        {
                          Header: 'Function Name',
                          accessor: 'FunctionName',
                          id: 'functionName',
                          filterMethod: (filter, rows) =>
                            caseInsensitiveFilter(filter, rows),
                          Filter: ({ filter, onChange }) => {
                            return (
                              <Input
                                onChange={(event, data) => {
                                  event.preventDefault();
                                  onChange(data.value);
                                  this.filterFunctionName = data.value;
                                }}
                                fluid
                                placeholder="Filter by FunctionName"
                              />
                            );
                          },
                        },
                        /**
                         * Access Column
                         */
                        {
                          Header: '',
                          id: 'IsPageAccessible',
                          accessor: 'IsPageAccessible',
                          filterMethod: (filter, rows) => false,
                          filterable: false,
                          Cell: ({ original, index }) => {
                            const initialValue = _.find(
                              initialAccessibleFunctions,
                              {
                                AccessInfoId: original.AccessInfoId,
                              }
                            )[FieldEnum.IsPageAccessible];
                            return (
                              <div style={{ textAlign: 'center' }}>
                                <TrackedCheckbox
                                  initialValue={initialValue}
                                  checked={original[FieldEnum.IsPageAccessible]}
                                  disabled={Allowed !== 1}
                                  onChange={() => {
                                    this.props.updateIsPageAccessible(
                                      original,
                                      FieldEnum.IsPageAccessible,
                                      Id,
                                      index
                                    );
                                  }}
                                />
                              </div>
                            );
                          },
                          maxWidth: 100,
                        },
                      ],
                    },
                  ]}
                />
              );
            }
          }}
        />
      </div>
    );
  }
}
const mapDispatchToProps = {
  updateAssignSiteData,
  checkAll,
  updateIsPageAccessible,
};
export const AssignSiteGrid = withRouter(
  connect(
    null,
    mapDispatchToProps
  )(AssignSiteGridContainer)
);



// WEBPACK FOOTER //
// ./src/pages/usersetup/components/AssignSiteGrid.js